/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Form_Name_DescriptionInputs */



/**
* | output |
* | --- |
* | "A friendly name shown to users in the model selector." |
*
* @param {Private_Models_Form_Name_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_form_name_description = /** @type {((inputs?: Private_Models_Form_Name_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Form_Name_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein benutzerfreundlicher Name, der den Nutzern in der Modellauswahl angezeigt wird.")
	return /** @type {LocalizedString} */ ("A friendly name shown to users in the model selector.")
});